import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import {
    ROUTE_LOGIN,
    ROUTE_PAYMENTS,
    ROUTE_DASHBOARD,
    ROUTE_WELCOME,
    INDIVIDUAL_ROLE_ID,
    ROUTE_PARTNER_SIGNUP,
} from './constants';
import {
    isUserLoggedIn,
    getProfileCompleteStatus,
} from '../screens/auth/selectors';
import {
    getAuthToken,
    getUserPermissionsKeys,
} from '../screens/auth/selectors';
import {
    HAS_VISITED_WELCOME_SCREEN_KEY,
    DASHBOARD_VIEW,
} from '../screens/auth/constants';
import { setAuthToken } from '../api/utils';
import { setValue, getValue } from '../clients/storage';
import qs from 'query-string';
import { useLocation } from 'react-router';
import { AVAILABLE_PACKAGES } from '../screens/auth/constants';
import { getUserPermissionRoleId } from '../screens/auth/selectors';

function ProtectedRoute({
    children,
    isUserLoggedIn,
    permissions,
    authToken,
    permissionRoleId,
    hasCompletedProfile,
    ...rest
}) {
    const location = useLocation();
    const queryParams = qs.parse(location.search);

    // setting Auth token for the http client
    if (isUserLoggedIn) setAuthToken(authToken);
    return (
        <Route
            {...rest}
            render={({ location }) => {
                const hasVisitedWelcomeScreen = getValue(
                    HAS_VISITED_WELCOME_SCREEN_KEY,
                );

                if (isUserLoggedIn) {
                    let ROUTE_TO = ROUTE_DASHBOARD;

                    if (location.pathname.startsWith('/invite')) {
                        return children;
                    }

                    if (
                        (INDIVIDUAL_ROLE_ID.includes(permissionRoleId) &&
                            queryParams.package &&
                            AVAILABLE_PACKAGES[
                                queryParams.package.toUpperCase()
                            ] &&
                            location.pathname != ROUTE_PAYMENTS) ||
                        !permissions.includes(DASHBOARD_VIEW)
                    ) {
                        ROUTE_TO = ROUTE_PAYMENTS;
                        return (
                            <Redirect
                                to={{
                                    ...location,
                                    pathname: ROUTE_TO,
                                    state: { from: location },
                                }}
                            />
                        );
                    } else if (
                        !INDIVIDUAL_ROLE_ID.includes(permissionRoleId) &&
                        location.pathname == ROUTE_PAYMENTS
                    ) {
                        if (!hasVisitedWelcomeScreen && hasCompletedProfile) {
                            ROUTE_TO = ROUTE_WELCOME;
                            setValue(HAS_VISITED_WELCOME_SCREEN_KEY, true);
                        }
                        if (
                            !hasCompletedProfile &&
                            queryParams.package.toUpperCase() !== 'CSCIENCE'
                        ) {
                            ROUTE_TO = ROUTE_PARTNER_SIGNUP;
                        }
                        return (
                            <Redirect
                                to={{
                                    ...location,
                                    pathname: ROUTE_TO,
                                    state: { from: location },
                                }}
                            />
                        );
                    }
                }

                return isUserLoggedIn ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            ...location,
                            pathname: ROUTE_LOGIN,
                            state: { from: location },
                        }}
                    />
                );
            }}
        />
    );
}

ProtectedRoute.propTypes = {
    // components to be rendered inside
    children: PropTypes.node,

    // denotes whether the current user is logged in or not
    isUserLoggedIn: PropTypes.bool,

    authToken: PropTypes.string,

    /**
     * @property {array[string]} permissions - array containing all the permission keys of the current user
     */
    permissions: PropTypes.array.isRequired,

    //user role permission
    permissionRoleId: PropTypes.number,

    hasCompletedProfile: PropTypes.bool,
};

ProtectedRoute.defaultProps = {
    isUserLoggedIn: false,
    children: null,
    authToken: null,
    permissionRoleId: null,
    hasCompletedProfile: false,
};

const mapStateToProps = (state) => {
    return {
        isUserLoggedIn: isUserLoggedIn(state),
        authToken: getAuthToken(state),
        permissions: getUserPermissionsKeys(state),
        permissionRoleId: getUserPermissionRoleId(state),
        hasCompletedProfile: getProfileCompleteStatus(state),
    };
};

const ConnectedProtectedRoute = connect(mapStateToProps)(ProtectedRoute);

export default ConnectedProtectedRoute;
